import { UcoastEl } from '@/scripts/core/UcoastEl'
import EmblaCarousel, {
	type EmblaCarouselType,
	EmblaOptionsType,
} from 'embla-carousel'
import { addToggleThumbBtnsActive, getAttributeOrUndefined, qsRequired } from '@/scripts/core/global'
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import ClassNames from 'embla-carousel-class-names'
import AutoHeight from 'embla-carousel-auto-height'
import Autoplay from 'embla-carousel-autoplay'
import Fade from 'embla-carousel-fade'

export class TestimonialsSlider extends UcoastEl {
	static htmlSelector = 'testimonials-slider'
	autoRotate: boolean
	speedInSeconds?: string
	emblaApiMain?: EmblaCarouselType
	emblaApiThumb?: EmblaCarouselType
	constructor() {
		super()
		this.autoRotate = this.hasAttribute('data-embla-auto')
		this.speedInSeconds = getAttributeOrUndefined(
			'data-speed-seconds',
			this
		)
	}

	override connectedCallback() {
		super.connectedCallback()
		this.initSlider()
	}

	/*override onSectionLoad(_: string) {
		this.emblaApiMain?.destroy()
		this.emblaApiThumb?.destroy()
		this.initSlider()
		this.pause()
	}*/

	initSlider() {
		const OPTIONS: EmblaOptionsType = {
			inViewThreshold: 1,
			align: 'center',
			containScroll: false,
			duration: 10,
			loop: true,
		}
		const OPTIONS_THUMBS: EmblaOptionsType = {
			containScroll: 'keepSnaps',
			dragFree: true,
			align: 'start',
			breakpoints: {
				'(min-width: 750px)': { align: 'center' },
			},
		}
		const viewportNode = qsRequired('.embla__viewport', this)
		const viewportNodeThumbCarousel = <HTMLElement>(
			document.querySelector('.embla-thumbs__viewport')
		)
		this.emblaApiMain = this.autoRotate
			? EmblaCarousel(viewportNode, OPTIONS, [
					WheelGesturesPlugin(),
					ClassNames(),
					AutoHeight(),
					Autoplay({ jump: true }),
					Fade(),
				])
			: EmblaCarousel(viewportNode, OPTIONS, [
					WheelGesturesPlugin(),
					ClassNames(),
					AutoHeight(),
					Fade(),
				])

		this.emblaApiThumb = EmblaCarousel(
			viewportNodeThumbCarousel,
			OPTIONS_THUMBS
		)
		const removeThumbBtnsClickHandlers = addThumbBtnsClickHandlers(
			this.emblaApiMain,
			this.emblaApiThumb
		)
		const removeToggleThumbBtnsActive = addToggleThumbBtnsActive(
			this.emblaApiMain,
			this.emblaApiThumb
		)

		this.emblaApiMain
			.on('destroy', removeThumbBtnsClickHandlers)
			.on('destroy', removeToggleThumbBtnsActive)

		this.emblaApiThumb
			.on('destroy', removeThumbBtnsClickHandlers)
			.on('destroy', removeToggleThumbBtnsActive)
			.on('init', () => {
				window.setTimeout(() => {
					void window.Ucoast.mediaManager.loadAllInContainer(this)
					const slides = this.querySelectorAll('.testimonials-slider__slide')
					slides.forEach(slide => {
						const quote = slide.querySelector('.testimonials-slider__quote')
						const heading = slide.querySelector('.testimonials-slider__heading')
						if (quote) quote.style.transition = 'opacity 0.5s ease'
						if (heading) heading.style.transition = 'opacity 0.5s ease'

						setTimeout(() => {
							if (quote) quote.style.opacity = '1'
							if (heading) heading.style.opacity = '1'
						}, 100)
					})
				}, 3)
			})

		this.classList.remove('loading')
	}
	override animateIn() {
		super.animateIn()
		this.play()
	}
	override animateOut() {
		super.animateOut()
		this.pause()
	}
	play() {
		this.emblaApiMain?.plugins()?.autoplay?.play()
	}
	pause() {
		this.emblaApiMain?.plugins()?.autoplay?.stop()
	}
}

const addThumbBtnsClickHandlers = (
	emblaApiMain: EmblaCarouselType,
	emblaApiThumb: EmblaCarouselType
): (() => void) => {
	const slidesThumbs = emblaApiThumb.slideNodes()
	const autoplay = emblaApiMain?.plugins()?.autoplay

	const scrollToIndex = slidesThumbs.map((_, index) => (): void => {
		emblaApiMain.scrollTo(index)
		if (autoplay) {
			autoplay.stop()
		}
	})

	slidesThumbs.forEach((slideNode, index) => {
		slideNode.addEventListener('click', scrollToIndex[index], false)
	})

	return (): void => {
		slidesThumbs.forEach((slideNode, index) => {
			slideNode.removeEventListener('click', scrollToIndex[index], false)
		})
	}
}
